import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-lexoffice',
  standalone: true,
  imports: [],
  templateUrl: './lexoffice.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './lexoffice.component.scss'
})
export class LexofficeComponent {


}
